import React from 'react';
import './Hero.css';

function Hero() {
  const scrollToMenu = () => {
    const menuSection = document.querySelector('.menu-showcase');
    if (menuSection) {
      menuSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-decorations">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>
      <div className="hero-content">
        <div className="coming-soon-badge">
          <span className="badge-icon">🔥</span>
          Coming Soon
          <span className="badge-icon">🔥</span>
        </div>
        <h1 className="hero-title">
          <span className="title-main">IdlyKadai</span>
          <span className="title-accent">🍛</span>
        </h1>
        <p className="hero-tagline">
          Authentic Traditional South Indian Cuisine
        </p>
        <div className="hero-features">
          <div className="feature-badge">✨ All Dishes $5</div>
          <div className="feature-badge">🚚 Fast Delivery</div>
          <div className="feature-badge">🌶️ Authentic Taste</div>
        </div>
      </div>
      <div className="scroll-indicator" onClick={scrollToMenu}>
        <span>Explore Menu</span>
        <span className="scroll-arrow">↓</span>
      </div>
    </section>
  );
}

export default Hero;
